export const PERAHAN_INFO = {
  phone: "(021) 35883821",
  whatsapp: "+923035074455",
  email: "info@perahan.pk",
  address: "31-C Sunset Commercial Street #1, DHA Phase IV, Karachi",
  founded: 1983,
  founder: "Nasra Omar"
};

export const HERO_SLOGANS = [
  "Handcrafted Elegance Since 1983",
  "Tradition Woven Into Every Thread",
  "Timeless Block Prints. Made by Hand, Made with Heart.",
  "Rooted in Heritage. Worn with Grace.",
  "From Artisan Hands to Your Wardrobe"
];

export const COLLECTION_ITEMS = [
  {
    id: 1,
    title: "Heritage Paisley Kurta",
    description: "Hand-blocked cotton with traditional paisley motifs",
    image: "https://static.wixstatic.com/media/f85fef_e6139835aeaf46dd8e97b54b173b5ed0~mv2_d_3888_2592_s_4_2.jpg/v1/fill/w_400,h_500,q_90,enc_avif,quality_auto/f85fef_e6139835aeaf46dd8e97b54b173b5ed0~mv2_d_3888_2592_s_4_2.jpg"
  },
  {
    id: 2,
    title: "Artisan Dupatta",
    description: "Fine cotton with geometric block prints           .",
    image: "https://static.wixstatic.com/media/f85fef_279592451a89406ebb352432edf061bc~mv2_d_3888_2592_s_4_2.jpg/v1/fill/w_400,h_500,q_90,enc_avif,quality_auto/f85fef_279592451a89406ebb352432edf061bc~mv2_d_3888_2592_s_4_2.jpg"
  },
  {
    id: 3,
    title: "Classic Ensemble",
    description: "Premium cotton with traditional motifs",
    image: "https://static.wixstatic.com/media/f85fef_9a3b9f821ce34d458687268febf8a3e3~mv2_d_3888_2592_s_4_2.jpg/v1/fill/w_400,h_500,q_90,enc_avif,quality_auto/f85fef_9a3b9f821ce34d458687268febf8a3e3~mv2_d_3888_2592_s_4_2.jpg"
  },
  {
    id: 4,
    title: "Traditional Print Collection",
    description: "Handcrafted with intricate block-printed designs",
    image: "https://static.wixstatic.com/media/f85fef_d952410ce87f455ba80b91aba11cd46c~mv2_d_3888_2592_s_4_2.jpg/v1/fill/w_400,h_500,q_90,enc_avif,quality_auto/f85fef_d952410ce87f455ba80b91aba11cd46c~mv2_d_3888_2592_s_4_2.jpg"
  },
  {
    id: 5,
    title: "Heritage Fabric Collection",
    description: "Elegant traditional patterns on premium fabric",
    image: "https://static.wixstatic.com/media/f85fef_c51ea0db83e34d08add541a93d532125~mv2_d_2592_3888_s_4_2.jpg/v1/fill/w_400,h_500,q_90,enc_avif,quality_auto/f85fef_c51ea0db83e34d08add541a93d532125~mv2_d_2592_3888_s_4_2.jpg"
  }
];

export const ARTISAN_PROCESS_STEPS = [
  {
    step: 1,
    title: "Designing the Motif",
    description: "Traditional patterns are carefully sketched and planned",
    image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&h=300"
  },
  {
    step: 2,
    title: "Carving Wooden Blocks",
    description: "Master craftsmen carve intricate designs into wood",
    image: "https://images.unsplash.com/photo-1504703395950-b89145a5425b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&h=300"
  },
  {
    step: 3,
    title: "Mixing Natural Dyes",
    description: "Eco-friendly colors from natural sources",
    image: "https://images.unsplash.com/photo-1541336032412-2048a678540d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=400&h=300"
  },
  {
    step: 4,
    title: "Hand Printing",
    description: "Precise stamping creates beautiful patterns",
    image: "https://pixabay.com/get/gfd94ca9aa15ef259b5d58190493466b775ba2d639c06369aa12e50a75a980967196d944b1e967a57d6f1d25309aa39b0d7ab91f2ae3c30a0e4229153a34f6967_1280.jpg"
  },
  {
    step: 5,
    title: "Drying & Fixing",
    description: "Colors are set through traditional methods",
    image: "https://pixabay.com/get/g6f284fc41e486b1526e0de82c4acb545bc05d0cf7f32a4a85d43c679812c67a1e933db27b959462a99f6cd1040a815d26305332342aaaba853774c18beb5f1f2_1280.jpg"
  },
  {
    step: 6,
    title: "Tailoring & Finishing",
    description: "Expert tailors create the final masterpiece",
    image: "https://pixabay.com/get/g3449fcecc787c3437a8e230b8a34b676978b569662306caaa60aaeebd0a5ea1fc491d2a1d05718090b17d62619c1cc5966f15229f4d1833ef2610cca23ad667a_1280.jpg"
  }
];
